import axiosService from '../services/axiosService';

const LIST_URL = {
    GET_BY_PARENT: '/api/Location/GetByParentId',
};

const locationApis = {
    getByParent: (parentId) => {
        return axiosService.post(`${LIST_URL.GET_BY_PARENT}/${parentId}`);
    },
};

export default locationApis;
